module.exports = __webpack_public_path__ + "img/uk-cardiovascular-diseases-female.9180a319.png";